export const initialState = {
  actionProcessing: false,
  users: [],
  selectedAgentId: null,
};
